module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo17-8173ce37a946059875358ea69e5151ae.jpg";